// src/features/auth/authThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { loginApi, getMeApi, signoutApi } from "../../api/authApi";
import { listCurrentUserNotificationsApi, markAllCurrentUserNotificationsReadApi } from "../../api/notificationApi";
import { listCurrentUserConversationsApi } from "../../api/chatApi";
import i18n from "../../i18n";

// 🔥 LOGIN
export const login = createAsyncThunk(
  "auth/login",
  async (credentials: { email: string; password: string }, thunkAPI) => {
    try {
      const response = await loginApi(credentials);
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue({
        code: err?.response?.data?.code || "LOGIN_FAILED",
        message: err?.response?.data?.message || i18n.t("system.serverError"),
      });
    }
  }
);

// 🔥 FETCH CURRENT USER (appel au /me)
export const fetchCurrentUser = createAsyncThunk(
  "auth/fetchCurrentUser",
  async (_, thunkAPI) => {
    try {
      const response = await getMeApi();
      return response.data;
    } catch (err: any) {
      const status = Number(err?.response?.status || 0);
      if (status === 401 || status === 403) return null;
      return thunkAPI.rejectWithValue(i18n.t("system.cannotLoadUser"));
    }
  }
);

export const fetchCurrentUserNotifications = createAsyncThunk(
  "auth/fetchCurrentUserNotifications",
  async (_, thunkAPI) => {
    try {
      const response = await listCurrentUserNotificationsApi(120);
      return {
        data: Array.isArray(response?.data?.data) ? response.data.data : [],
        unreadCount: Number(response?.data?.unreadCount || 0),
      };
    } catch (err: any) {
      const status = Number(err?.response?.status || 0);
      if (status === 401 || status === 403) return { data: [], unreadCount: 0 };
      return thunkAPI.rejectWithValue(i18n.t("system.serverError"));
    }
  }
);

export const markAllNotificationsAsRead = createAsyncThunk(
  "auth/markAllNotificationsAsRead",
  async (_, thunkAPI) => {
    try {
      await markAllCurrentUserNotificationsReadApi();
      return { ok: true };
    } catch (err: any) {
      const status = Number(err?.response?.status || 0);
      if (status === 401 || status === 403) return { ok: true };
      return thunkAPI.rejectWithValue(i18n.t("system.serverError"));
    }
  }
);

export const fetchCurrentUserConversations = createAsyncThunk(
  "auth/fetchCurrentUserConversations",
  async (_, thunkAPI) => {
    try {
      const response = await listCurrentUserConversationsApi();
      return {
        data: Array.isArray(response?.data?.data) ? response.data.data : [],
        unreadCount: Number(response?.data?.unreadCount || 0),
      };
    } catch (err: any) {
      const status = Number(err?.response?.status || 0);
      if (status === 401 || status === 403) return { data: [], unreadCount: 0 };
      return thunkAPI.rejectWithValue(i18n.t("system.serverError"));
    }
  }
);

export const logoutCurrentUser = createAsyncThunk(
  "auth/logoutCurrentUser",
  async (_, thunkAPI) => {
    try {
      await signoutApi();
      return { ok: true };
    } catch (err: any) {
      const status = Number(err?.response?.status || 0);
      if (status === 401 || status === 403) return { ok: true };
      return thunkAPI.rejectWithValue(i18n.t("system.serverError"));
    }
  }
);
